<template>
  <section class="book-info">
    <div class="p-4">
      <h4 class="text-base italic font-medium dark:text-gray-500">
        {{ metadata.title }}
      </h4>
      <div
        v-if="metadata.subtitle"
        class="italic tracking-tight text-gray-400 dark:text-gray-600"
      >
        {{ metadata.subtitle }}
      </div>
      <div class="mt-2">
        by
        <span class="font-medium dark:text-gray-500">{{
          metadata.author
        }}</span>
      </div>
      <div class="mt-4">
        Book location:
        <a
          v-if="metadata.location.includes('://')"
          :href="metadata.location"
          v-html="locationString"
        ></a>
        <span class="font-mono dark:text-gray-500" v-else>{{
          metadata.location
        }}</span>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    metadata: Object
  },
  computed: {
    locationString() {
      if (this.metadata.location.startsWith("kindle")) return "Kindle";
      if (this.metadata.location.includes(":8083")) return "Digital Library";
      if (this.metadata.location.startsWith("http")) {
        const url = new URL(this.metadata.location);
        return url.hostname;
      }
    }
  }
})
export default class Book extends Vue {
  metadata!: object;
}
</script>
